import type { TemplateAttribute } from '@/lib/api/client'

export const generateThemeTemplateAttributes = async ({
  templateAttributes,
}: {
  templateAttributes: TemplateAttribute[]
}) => {
  const templateDataTypes = ['image', 'note', 'view', 'table']

  const themeTemplateAttributes: Partial<TemplateAttribute>[] = []

  for (const templateAttribute of templateAttributes) {
    const dataType = templateAttribute.data_type

    if (!templateDataTypes.includes(dataType)) {
      continue
    }

    const overrides: any = {}

    if (dataType === 'table') {
      overrides.rows = []
    }

    if (dataType === 'note') {
      overrides.content = '<p></p>'
    }

    if (dataType === 'view') {
      overrides.viewId = null
      overrides.type = 'view'
    }

    if (dataType === 'image') {
      overrides.imageId = null
      overrides.type = 'image'
    }

    const tmplValues = {
      ...templateAttribute.template_values,
      ...overrides,
    }

    delete tmplValues?.subPageId

    themeTemplateAttributes.push({
      creator: 0,
      data_type: templateAttribute.data_type,
      template_values: tmplValues,
    })
  }

  return themeTemplateAttributes
}
